export const selectDataSubjectRightManagementTask = (state) =>
  state.privacykitDataSubjectRightManagement.task;

export const selectDataSubjectRightManagementManageTask = (state) =>
  state.privacykitDataSubjectRightManagement.task.manageTask;
